import './FederatedLoginButton.scss';

import { ButtonV2 } from '@travelwin/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IdentityProvider, useUser } from '../../context/User';
import Modal from '../Modal';
import { AppleLogo } from './components/AppleLogo';
import { GoogleLogo } from './components/GoogleLogo';

interface Props {
  afterAuthPath?: string;
  variation?: 'default' | 'simple';
}

const className = 'c-FederatedLoginButton';

const FederatedLoginButton = ({
  afterAuthPath,
  variation = 'default',
}: Props) => {
  const { t } = useTranslation();
  const { federatedSignIn } = useUser();
  const [isShowAppleReminder, setIsShowAppleReminder] = useState(false);

  const renderAppleReminder = () => {
    return (
      <Modal
        on={isShowAppleReminder}
        toggle={() => setIsShowAppleReminder(false)}
      >
        <div className={`${className}__apple-reminder`}>
          <div className={`${className}__apple-reminder-title`}>
            {t('login.appleReminder.title', 'Use Your Real Email Address')}
          </div>
          <p className={`${className}__apple-reminder-text`}>
            {t(
              'login.appleReminder.text',
              "If you sign up with Apple, please don’t use 'Hide My Email.' We need your real email to send order updates, help with password resets, and provide support.",
            )}
          </p>
          <ButtonV2
            fluid
            onClick={() =>
              federatedSignIn(IdentityProvider.Apple, afterAuthPath)
            }
            icons={{ leading: <AppleLogo /> }}
          >
            {t('login.continueWithApple', 'Continue with Apple')}
          </ButtonV2>
        </div>
      </Modal>
    );
  };

  return (
    <div className={className}>
      {isShowAppleReminder && renderAppleReminder()}
      <div className={`${className}__buttons--${variation}`}>
        <ButtonV2
          onClick={() =>
            federatedSignIn(IdentityProvider.Google, afterAuthPath)
          }
          icons={{ leading: <GoogleLogo /> }}
        >
          {variation === 'default' &&
            t('login.continueWithGoogle', 'Continue with Google')}
        </ButtonV2>
        <ButtonV2
          onClick={() => setIsShowAppleReminder(true)}
          icons={{ leading: <AppleLogo /> }}
        >
          {variation === 'default' &&
            t('login.continueWithApple', 'Continue with Apple')}
        </ButtonV2>
      </div>
      {variation === 'default' && (
        <div className={`${className}__divider`}>{t('login.or', 'or')}</div>
      )}
    </div>
  );
};

export default FederatedLoginButton;
